import { render, staticRenderFns } from "./StartupMetrics.vue?vue&type=template&id=2c4238e9"
import script from "./StartupMetrics.vue?vue&type=script&lang=js"
export * from "./StartupMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports